import { InstagramOutlined, RightOutlined } from "@ant-design/icons";

const Footer = () => {
  return (
    <footer className="footer-area" style={{ textAlign: "center" }}>
      <div className="footer-area-section">
        <div className="footer-area-section-text">
          Initiated by Arabic Type Unit at AUB | Funded by URB and AFAC/ACSS
          “Research on the Arts Program” Third Cycle (2021/22)
        </div>
        <div className="footer-area-section-icons">
          <RightOutlined className="footer-area-section-icons-icon" />
          <a
            rel="noreferrer"
            className="footer-area-link"
            href="https://www.instagram.com/arabictypeunit?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw%3D%3D"
            target="_blank"
          >
            <InstagramOutlined className="footer-area-section-icons-icon" />
          </a>
        </div>
        <div className="footer-area-section-author">
          Designed by Nayla Hamze
        </div>
      </div>
    </footer>
  );
};

export default Footer;
